<template>
    <div class="container-fluid">
        <admin-header :name="$t('Clients')" @create="newClient" :add-new="addNewBtn"/>
        <router-view name="clients"/>
    </div>
</template>

<script>
export default {
    computed: {
        addNewBtn() {
            return this.$route.fullPath == '/auth/clients' || this.$route.fullPath == '/auth/clients/';
        }
    },
    methods: {
        newClient() {
            this.$router.push({name:'clients.create'});
        }
    },
    metaInfo() {
        return {
            title: this.$t('Clients')
        };
    }
};
</script>
